import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table} from 'semantic-ui-react';
import ProductRow from "../ProductRow/index";
import {getTranslate} from "react-localize-redux";

class ProductTable extends Component {


    render() {

        if (this.props.product) {
            const {product} = this.props;
            return (
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>{this.props.translate('inventory.table.header.code')}</Table.HeaderCell>
                            <Table.HeaderCell>{this.props.translate('inventory.table.header.size')}</Table.HeaderCell>
                            <Table.HeaderCell>{this.props.translate('inventory.table.header.vintage')}</Table.HeaderCell>
                            <Table.HeaderCell>{this.props.translate('inventory.table.header.box')}</Table.HeaderCell>
                            <Table.HeaderCell>{this.props.translate('inventory.table.header.difference')}</Table.HeaderCell>
                            <Table.HeaderCell>{this.props.translate('inventory.table.header.inStock')}</Table.HeaderCell>
                            <Table.HeaderCell>{this.props.translate('inventory.table.header.count')}</Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <ProductRow noMatrix product={product}/>
                    </Table.Body>
                </Table>
            )
        }

        const {group} = this.props;

        return (
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>{this.props.translate('inventory.table.header.code')}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate('inventory.table.header.size')}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate('inventory.table.header.vintage')}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate('inventory.table.header.box')}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate('inventory.table.header.difference')}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate('inventory.table.header.inStock')}</Table.HeaderCell>
                        <Table.HeaderCell>{this.props.translate('inventory.table.header.count')}</Table.HeaderCell>
                        <Table.HeaderCell></Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {group.sort((a, b) => {
                        return Number.parseInt(a.variations[0].code, 10) - Number.parseInt(b.variations[0].code, 10) === 0 ?
                            Number.parseInt(a.variations[1].code, 10) - Number.parseInt(b.variations[1].code, 10) :
                            Number.parseInt(a.variations[0].code, 10) - Number.parseInt(b.variations[0].code, 10)
                    }).map((product) => {

                        return (
                            <ProductRow product={product} key={product.id}/>
                        )

                    })}
                </Table.Body>
            </Table>
        )
    }


}



const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductTable);



// WEBPACK FOOTER //
// ./src/scenes/Inventory/components/ProductTable/index.js